module.exports = __webpack_public_path__ + "static/cake_rose-1a91e2d3e5072de81963bdbf9c60d824.jpg";